import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({});

export default class ContestEntryModel extends Model.extend(Validations) {
  @attr('string') email;
  @attr('number') status;
  @attr('json') data;

  @belongsTo('contest', { async: true, inverse: null }) contest;

  // Meta fields
  @attr cmsCreated;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.email;
  }

  get displayLabel() {
    return this.email;
  }
}
